import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <>
    <path
      d="M19.6363 4.36358H17.4545V2.18176H6.5454V4.36358H4.36358C3.16358 4.36358 2.18176 5.3454 2.18176 6.5454V7.63631C2.18176 10.4181 4.27631 12.6872 6.97085 13.0254C7.65813 14.6618 9.13085 15.8945 10.909 16.2545V19.6363H6.5454V21.8181H17.4545V19.6363H13.0909V16.2545C14.869 15.8945 16.3418 14.6618 17.029 13.0254C19.7236 12.6872 21.8181 10.4181 21.8181 7.63631V6.5454C21.8181 5.3454 20.8363 4.36358 19.6363 4.36358ZM4.36358 7.63631V6.5454H6.5454V10.7127C5.27994 10.2545 4.36358 9.05449 4.36358 7.63631ZM19.6363 7.63631C19.6363 9.05449 18.7199 10.2545 17.4545 10.7127V6.5454H19.6363V7.63631Z"
      fill="url(#paint0_linear_2614_663)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2614_663"
        x1="3.99994"
        y1="5.45449"
        x2="18.5454"
        y2="17.0909"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A8B2B4" />
        <stop offset="0.254808" stopColor="#C8CFCF" />
        <stop offset="0.673077" stopColor="#9AA2A5" />
        <stop offset="1" stopColor="#596163" />
      </linearGradient>
    </defs>
  </>,
  'SilverCup'
);
